import { ListItem, ListItemText } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { getTeamHistory, ITeam } from 'wisestep-api';
import { WsDrawer, Item } from 'wisestep-base';

export interface ITeamHistoryProps {
  team: ITeam;
  open: boolean;
  handleClose: () => void;
}

const TeamHistory = ({ team, open, handleClose }: ITeamHistoryProps) => {
  const [teamHistory, setTeamHistory] = useState<string[]>([]);

  const getHistory = useCallback(async () => {
    const response = await getTeamHistory(team.id ?? '');
    response.data.map((data) => {
      if (data.action === 'new')
        setTeamHistory((prev) => [
          ...prev,
          (data.firstName + ' ' + data.lastName || data.createdBy) + ' created ' + team.name,
        ]);
      else if (data.action === 'update')
        setTeamHistory((prev) => [
          ...prev,
          (data.firstName + ' ' + data.lastName || data.createdBy) + ' updated ' + team.name,
        ]);
      else if (data.action === 'newteammember')
        setTeamHistory((prev) => [
          ...prev,
          (data.firstName + ' ' + data.lastName || data.createdBy) + ' added a new member',
        ]);
      else if (data.action === 'deleteteammember')
        setTeamHistory((prev) => [
          ...prev,
          (data.firstName + ' ' + data.lastName || data.createdBy) + ' removed a team member',
        ]);
    });
  }, [team]);

  useEffect(() => {
    getHistory();
  }, [getHistory]);

  return (
    <WsDrawer title={''} open={open} onClose={handleClose}>
      <>
        {teamHistory.map((log, i) => (
          <Item elevation={1} key={i}>
            <ListItem key={i}>
              <ListItemText primary={log} />
            </ListItem>
          </Item>
        ))}
      </>
    </WsDrawer>
  );
};

export default TeamHistory;
